import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { designType } from '../../interfaces/enumDesignType';
import { sizeType } from '../../interfaces/enumSizeType';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rr-btn',
  standalone: true,
  imports: [CommonModule, IconComponent],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './btn.component.html',
  styleUrl: './btn.component.scss'
})
export class BtnComponent {
  @Input() iconStart = '';
  @Input() iconEnd = '';
  @Input() disabled = false;
  @Input() type: string = designType.Default as string;
  @Input() size: string | undefined = sizeType.Medium;

  @Output() btnclick = new EventEmitter<any>();



}
